export default __webpack_public_path__ + "static/media/110.1e6d0a15.png";